import styles from '@/styles/events.module.scss';

/** EventCard — карточка мероприятия в результатах */
export default function EventCard({ event, onClick }) {
    const title = event.displayName || event.title;

    return (
        <div className={styles.card} onClick={() => onClick(event.id)} role="button" tabIndex={0}>
            {event.image ? (
                <img className={styles.thumb} src={event.image} alt={title} loading="lazy" />
            ) : (
                <div className={styles.thumb}>{title}</div>
            )}
            <div className={styles.info}>
                <div className={styles.name}>
                    {title}
                    {event.is_top_event && <span className={styles.badge}>Top</span>}
                </div>
                {event.date && (
                    <div className={styles.meta}>
                        <span>{event.date}</span>
                    </div>
                )}
            </div>
            <span className={styles.arrow}>›</span>
        </div>
    );
}